import { jsx as _jsx } from "react/jsx-runtime";
import { getAllChildEdgeTypeMatrixEntries, getAllParentEdgeTypeMatrixEntries } from '@iotv/datamodel-core';
import { AdjacentType, } from '../../../../types/AppTypes';
import ObjectListCard from './ObjectListCard'; //v2
const debug = process.env.REACT_APP_DEBUG && false;
export const getListsForObject = ({ viewObject, mostProximateCustomer, userGroupRoles, applicationData, userFunctions, transactionFunctions, }) => {
    if (!viewObject.matchedPrimary)
        return [];
    return getListsDefinitionsForObject(viewObject.matchedPrimary).map((listDef) => {
        if (listDef) {
            const { adjacentFilter, listConfigParams, attKey } = listDef;
            return (_jsx(ObjectListCard, { viewObject, mostProximateCustomer, userGroupRoles, userFunctions, applicationData, transactionFunctions, adjacentFilter, listConfigParams }, attKey));
        }
        else
            return null;
    });
};
const edgeTypeMatrixEntryToListAttributes = ({ fromObjectInstance, toObjectType, adjacentType, edgeTypeMatrixEntry, }) => {
    let listAttributes = null;
    const { edgeTypeId, labels, cardinality, edgeAttributes } = edgeTypeMatrixEntry;
    switch (adjacentType) {
        case AdjacentType.PARENT:
            listAttributes = {
                adjacentFilter: {
                    adjacentType,
                    objectType: toObjectType,
                    edgeFilter: { edgeTypeId },
                    filterConfig: undefined,
                    otherObjectType: fromObjectInstance.type,
                },
                listConfigParams: { label: labels.in },
                attKey: edgeTypeId,
            };
            break;
        case AdjacentType.CHILD: {
            listAttributes = {
                adjacentFilter: {
                    adjacentType,
                    objectType: toObjectType,
                    edgeFilter: { edgeTypeId },
                    filterConfig: undefined,
                    otherObjectType: fromObjectInstance.type,
                },
                listConfigParams: { label: labels.out },
                attKey: edgeTypeId,
            };
        }
    }
    return listAttributes;
};
export const getListsDefinitionsForObject = (matchedPrimary) => {
    const definitions = [];
    const targetMappedChildEntries = getAllChildEdgeTypeMatrixEntries(matchedPrimary.type);
    const sourceMappedParentEntries = getAllParentEdgeTypeMatrixEntries(matchedPrimary.type);
    debug && console.log(matchedPrimary.type, { targetMappedChildEntries });
    Object.entries(sourceMappedParentEntries).forEach(([sourceObjectType, edgeMatrixEntries]) => {
        edgeMatrixEntries.forEach((edgeTypeMatrixEntry) => {
            let allow = true;
            /** Parent of Group exception */
            if (matchedPrimary.type === 'Group') {
                if (sourceObjectType !== 'Group' && sourceObjectType !== (matchedPrimary.supportedType ?? 'never')) {
                    allow = false;
                }
            }
            if (allow) {
                definitions.push(edgeTypeMatrixEntryToListAttributes({
                    adjacentType: AdjacentType.PARENT,
                    edgeTypeMatrixEntry,
                    fromObjectInstance: matchedPrimary,
                    toObjectType: sourceObjectType,
                }));
            }
        });
    });
    Object.entries(targetMappedChildEntries).forEach(([targetObjectType, edgeMatrixEntries]) => {
        edgeMatrixEntries.forEach((edgeTypeMatrixEntry) => {
            let allow = true;
            /** Child of Group exception */
            if (matchedPrimary.type === 'Group') {
                if (targetObjectType !== 'Group' && targetObjectType !== (matchedPrimary.supportedType ?? 'never')) {
                    allow = false;
                }
            }
            if (allow) {
                definitions.push(edgeTypeMatrixEntryToListAttributes({
                    adjacentType: AdjacentType.CHILD,
                    edgeTypeMatrixEntry,
                    fromObjectInstance: matchedPrimary,
                    toObjectType: targetObjectType,
                }));
            }
        });
    });
    return definitions.filter((d) => d !== undefined && d !== null).sort((a, b) => a.attKey.localeCompare(b.attKey));
};
